import { Helmet } from "react-helmet-async";
import { Phone, Mail, Clock } from "lucide-react";
import QuoteForm from "@/web/components/quote-form";

export default function FreeQuote() {
  return (
    <>
      <Helmet>
        <title>Get a Free Quote | Cool Wave Mangawhai HVAC</title>
        <meta
          name="description"
          content="Tell us about your project and we'll come back with a no-pressure quote within one business day."
        />
      </Helmet>

      <div className="bg-[linear-gradient(to_bottom,#EAF6FE_0%,#EAF6FE_97%,#FFFFFF_100%)]">
      <section className="pb-2 pt-14 md:pb-4 md:pt-16">
        <div className="container max-w-3xl">
          <h1 className="mb-3 text-4xl font-bold tracking-tight md:text-5xl">Get a Free Quote</h1>
          <p className="text-lg text-body">
            Tell us about your project and we'll get back to you within one business day.
          </p>
        </div>
      </section>

      <section className="container pb-14 pt-4 md:pb-16 md:pt-6">
        <div className="grid gap-10 lg:grid-cols-[1.4fr,1fr] lg:gap-14">
          <div>
            <QuoteForm />
          </div>
          <aside>
            <div className="rounded-xl border border-border/60 bg-white p-6">
              <h2 className="mb-4 text-lg font-semibold">Prefer to call?</h2>
              <ul className="space-y-4 text-sm text-body">
                <li className="flex gap-3">
                  <Phone className="mt-0.5 h-5 w-5 flex-none text-brand" />
                  <div className="min-w-0 flex-1">
                    <div className="text-xs uppercase tracking-wider text-body/60">Phone</div>
                    <a href="tel:0272980080" className="cursor-pointer text-base font-semibold text-ink [overflow-wrap:anywhere] hover:text-brand">027 298 0080</a>
                  </div>
                </li>
                <li className="flex gap-3">
                  <Mail className="mt-0.5 h-5 w-5 flex-none text-brand" />
                  <div className="min-w-0 flex-1">
                    <div className="text-xs uppercase tracking-wider text-body/60">Email</div>
                    <a href="mailto:gavin@coolwave.co.nz" className="cursor-pointer text-base font-semibold text-ink [overflow-wrap:anywhere] hover:text-brand">gavin@coolwave.co.nz</a>
                  </div>
                </li>
                <li className="flex gap-3">
                  <Clock className="mt-0.5 h-5 w-5 flex-none text-brand" />
                  <div className="min-w-0 flex-1">
                    <div className="text-xs uppercase tracking-wider text-body/60">Hours</div>
                    <div className="text-base font-semibold text-ink">8am–5pm Mon–Fri</div>
                    <div className="text-xs text-body">After-hours urgent work — please enquire.</div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-6 rounded-xl bg-brand-50 p-6 text-lg text-brand-800">
              <strong className="block text-lg text-brand-900">Local & Certified</strong>
              Mangawhai-based, Certified Panasonic Installer, 20+ years across Northland and Auckland.
            </div>
          </aside>
        </div>
      </section>
      </div>
    </>
  );
}
